import request from '@/utils/request';

const PATH = '/popup';

export const getPopupList = () => request({
  url: PATH,
  method: 'get',
});
